import React from 'react';
import {
    PRODUCT_NAME,
    COMPANY_LEGAL_NAME,
    PRODUCT_SUPPORT_EMAIL,
    PRODUCT_WEBSITE,
    PRODUCT_PLATFORM
} from '../constants/constants';

const PrivacyPolicy_es = () => {
    return (

        <>

            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} >
                <div style={{ width: '90%' }}>

                    <p>
                        <strong><span>POLÍTICA DE PRIVACIDAD</span></strong>
                    </p>
                    <p>
                        <span> </span>
                    </p>
                    <p>
                        <span>La Fundación de la Biblioteca Pública de Nashville, una corporación sin ánimo de lucro de Tennessee. (“</span><strong><span>NPLF</span></strong><span>”, “</span><strong><span>Nosotros</span></strong><span>”, “</span><strong><span>Nos</span></strong><span>” o “</span><strong><span>Nuestro</span></strong><span>”), se compromete a garantizar la privacidad y seguridad de usted (“</span><strong><span>Usuario</span></strong><span>”, “</span><strong><span>Usted</span></strong><span>” o “</span><strong><span>Su</span></strong><span>”), así como su acceso y uso del programa Begin Bright, incluyendo todo el contenido, la funcionalidad y los servicios ofrecidos en o a través de la plataforma disponible en</span><span> </span><a href="http://platform.beginbright.org/"><span>platform.beginbright.org</span></a><span> </span><span>(la “</span><strong><span>Plataforma</span></strong><span>”). NPLF y el Usuario pueden denominarse en singular como “</span><strong><span>Parte</span></strong><span>” y colectivamente como las “</span><strong><span>Partes</span></strong><span>”.</span>
                    </p>
                    <p>
                        <span> </span>
                    </p>
                    <p>
                        <span>NPLF se compromete a salvaguardar la privacidad del Usuario y sus datos, información y otros datos de identificación personal mediante el cumplimiento de esta política (la “</span><strong><span>Política de privacidad</span></strong><span>”). La presente Política de privacidad, disponible en </span><a href="http://platform.beginbright.org/privacy"><span>platform.beginbright.org/privacy</span></a><span>, informa al Usuario sobre los tipos de información que podemos recopilar de usted o que usted puede proporcionar cuando accede o utiliza la Plataforma. Además, esta Política de Privacidad detalla nuestras prácticas para recopilar, utilizar, mantener, conservar, proteger y divulgar sus datos e información, incluidos sus Datos Personales (tal y como se definen en el presente documento).</span>
                    </p>
                    <p>
                        <span> </span>
                    </p>
                    <p>
                        <span>Por favor lea esta Política de privacidad detenidamente en su totalidad para comprender nuestras políticas y prácticas con respecto a sus datos, información y otra documentación de identificación personal, y cómo recopilamos, utilizamos, mantenemos, protegemos y divulgamos lo anterior. Si no está de acuerdo con los términos de la Política de privacidad, puede utilizar la Plataforma. Al acceder, visitar o utilizar nuestra Plataforma, usted acepta los términos de esta Política de privacidad en su totalidad.</span>
                    </p>
                    <p>
                        <br /><span>La presente Política de privacidad puede cambiar ocasionalmente (“</span><strong><span>Cambios</span></strong><span>”). El uso continuado o el acceso a la Plataforma tras la introducción de Cambios por parte de NPLF se considerará como una aceptación de dichos cambios; por lo tanto, le rogamos que consulte periódicamente la presente Política de privacidad para conocer cualquier actualización, revisión, modificación o enmienda. Notificaremos al Usuario cualquier Cambio proporcionándole acceso a la nueva Política de Privacidad en la Plataforma. NPLF podrá notificar al Usuario por correo electrónico o mediante un aviso destacado en la Plataforma, antes o simultáneamente a la entrada en vigor de los Cambios, y NPLF actualizará la fecha que figura al final de esta Política de Privacidad (la “</span><strong><span>Fecha de entrada en vigor</span></strong><span>”). Si nuestras prácticas con respecto a los Datos personales (tal y como se definen en el presente documento) recopilados anteriormente cambian de forma que resulten sustancialmente menos restrictivas que las políticas vigentes en el momento en que recopilamos la información, NPLF hará todo lo posible por notificarlo y obtener el consentimiento para cualquier uso que pueda ser requerido por la ley.</span>
                    </p>
                    <p>
                        <span> </span>
                    </p>

                    <strong>I. Definiciones.</strong>
                    <p>
                        <strong><span> </span></strong>
                    </p>
                    <ol>

                        a.      “<strong>Afiliado</strong>” se refiere a cualquier Persona (tal y como se define en el presente documento), distinta de las Partes, que, directa o indirectamente, controle, esté controlada por o esté bajo el control común de una de las Partes.

                    </ol>
                    <p>
                        <span> </span>
                    </p>
                    <ol start="2">

                        b.      “<strong>Cookie</strong>” se refiere a un mensaje o segmento de datos que contiene información sobre un usuario, enviado por un servidor web a un navegador y devuelto al servidor cada vez que el navegador solicita una página web. Este mensaje o segmento de datos se almacena en el dispositivo del usuario (tal y como se define en el presente documento).

                    </ol>
                    <p>
                        <span> </span>
                    </p>
                    <ol start="3">

                        c.    “<strong>Responsable del tratamiento de datos</strong>” se refiere a la persona física o jurídica, sola o en conjunto con otras, que determina los fines y los medios del tratamiento de los datos personales (tal y como se definen en el presente documento). A los efectos de la presente Política de privacidad, NPLF es el responsable del tratamiento de su información y sus datos, incluidos los personales (tal y como se definen en el presente documento).

                    </ol>
                    <p>
                        <span> </span>
                    </p>
                    <ol start="4">

                        d.    “<strong>Responsable del procesamiento de datos</strong>” se refiere a cualquier persona física o jurídica, autoridad pública, agencia u otro organismo que procese su información y datos, incluidos los datos personales (tal y como se definen en el presente documento) en nombre del controlador de datos.

                    </ol>
                    <p>
                        <span> </span>
                    </p>
                    <ol start="5">

                        e.     “<strong>Titular de los datos</strong>” se refiere a cualquier persona física o jurídica identificada o identificable que utilice o acceda a la plataforma. A los efectos de la presente Política de privacidad, el interesado es el usuario.

                    </ol>
                    <p>
                        <span> </span>
                    </p>
                    <ol start="6">

                        f.     “<strong>Dispositivo</strong>” se refiere a cualquier unidad de hardware físico o equipo que proporcione una o más funciones dentro de un sistema informático, incluyendo, entre otros, computadoras de escritorio, computadoras portátiles (o de otro tipo), teléfonos móviles/celulares, tabletas y otras computadoras capaces de utilizar o acceder a la Plataforma.

                    </ol>
                    <p>
                        <span> </span>
                    </p>
                    <ol start="7">

                        g.      “<strong>Persona</strong>” significa cualquier individuo, corporación, sociedad, empresa conjunta, sociedad de responsabilidad limitada, autoridad gubernamental, organización no incorporada, fideicomiso, asociación u otra entidad.

                    </ol>
                    <p>
                        <span> </span>
                    </p>
                    <ol start="8">

                        h.      “<strong>Información personal</strong>” se refiere a cualquier información que pueda utilizarse para distinguir o rastrear la identidad de un Usuario individual, ya sea por sí sola o en combinación con otra información personal o identificativa, que esté vinculada o pueda vincularse a un individuo específico.

                    </ol>
                    <p>
                        <span> </span>
                    </p>
                    <ol start="9">

                        i.    “<strong>Procesamiento</strong>” hace referencia a cualquier operación o conjunto de operaciones que se realiza sobre datos o conjuntos de datos, ya sea por medios automatizados o no, como la recogida, el registro, la organización, la estructuración, el almacenamiento, la adaptación o la alteración, la recuperación, la consulta, el uso, la divulgación por transmisión, la difusión o cualquier otra forma de puesta a disposición, la alineación o la combinación, la restricción, la supresión o la destrucción.

                    </ol>
                    <p>
                        <span> </span>
                    </p>
                    <ol start="10">

                        j.      “<strong>Datos de uso</strong>” se refiere a determinados datos que se generan mediante el uso de Nuestra Plataforma, ya sea por un Usuario individual o por el uso general del sistema subyacente a la Plataforma.

                    </ol>
                    <p>
                        <span> </span>
                    </p>
                    <ol start="11">

                        k.      “<strong>Registro web</strong>” se refiere a un archivo creado y mantenido automáticamente por un servidor web, que contiene información sobre quién o qué visita, accede o utiliza la Plataforma, el punto de origen de quienes visitan, acceden o utilizan la Plataforma, y las actividades y el comportamiento de quienes visitan, acceden o utilizan la Plataforma.

                    </ol>
                    <p>
                        <span> </span>
                    </p>

                    <strong>II. Política de exclusión voluntaria.</strong>
                    <p>
                        <strong><span> </span></strong>
                    </p>
                    <ol>

                        a.    <strong>Exclusión voluntaria.</strong> El usuario reconoce que, de vez en cuando, puede recibir boletines informativos, actualizaciones, material de <em>marketing</em> o promocional y otras comunicaciones que NPLF, a su entera y absoluta discreción, considere que puedan ser de su interés. El usuario puede optar expresamente por no recibir ninguna o todas estas comunicaciones de NPLF accediendo a un enlace web para darse de baja o, alternativamente, notificándolo a NPLF de acuerdo con la sección titulada “<strong>Comentarios, inquietudes y quejas</strong>”. Es posible que pueda optar por no recibir anuncios personalizados de anunciantes y/o redes publicitarias que sean miembros o suscriptores de los siguientes: (i) la Iniciativa de Publicidad en Red (NAI por sus siglas en inglés) y (ii) los Principios de Autorregulación para la Publicidad Conductual en Línea de la Alianza de Publicidad Digital (DAA por sus siglas en inglés). Para obtener más información sobre sus opciones para excluirse de la publicidad personalizada, visite:

                    </ol>
                    <p>
                        <span> </span>
                    </p>

                    <ol>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        i. Iniciativa de Publicidad en Red (NAI por sus siglas en inglés) – Estados Unidos
                        <ol style={{ paddingLeft: 70 }}>
                            <li>
                                Exclusión voluntaria del navegador: <a href="http://www.networkadvertising.org/choices">http://www.networkadvertising.org/choices</a>
                            </li>
                        </ol>

                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        ii.  Alianza de Publicidad Digital (DAA por sus siglas en inglés) – Estados Unidos
                        <ol style={{ paddingLeft: 70 }}>
                            <li>
                                Exclusión voluntaria del navegador: <a href="http://www.aboutads.info/choices">http://www.aboutads.info/choices</a>
                            </li>
                            <li>
                                Exclusión voluntaria basada en aplicaciones móviles: <a href="https://youradchoices.com/appchoices">https://youradchoices.com/appchoices</a>
                            </li>
                        </ol>

                    </ol>
                    <p>
                        <span> </span>
                    </p>
                    <strong>III. Edad mínima; privacidad de los infantes.</strong>
                    <p>
                        <strong><span> </span></strong>
                    </p>
                    <ol>

                        a.    <strong>Protección de la privacidad de los niños en Internet.</strong> La Plataforma no está dirigida a Usuarios menores de trece (13) años. NPLF no tiene la intención de recopilar, ni recopila deliberadamente, Datos personales de personas menores de trece (13) años. Ningún Usuario menor de trece (13) años puede proporcionar Datos personales a NPLF o en la Plataforma.

                    </ol>
                    <p>
                        <span> </span>
                    </p>
                    <ol start="2">

                        b.    <strong>Notificación.</strong> Si tenemos conocimiento (o se nos informa) de que hemos recopilado o recibido Datos personales de cualquier Usuario menor de trece (13) años, sin verificación o consentimiento paterno, eliminaremos dichos Datos personales. Si tiene conocimiento o sospecha que NPLF podría tener cualquier información, incluidos datos personales, sobre cualquier usuario menor de trece (13) años, consulte la sección titulada “<strong>Comentarios, inquietudes y quejas</strong>” con el fin de informar a NPLF sobre la recopilación o recepción por parte de NPLF de datos personales de cualquier persona menor de trece (13) años.

                    </ol>
                    <p>
                        <span> </span>
                    </p>

                    <strong>IV. Procesamiento de la información y los datos.</strong>
                    <p>
                        <strong><span> </span></strong>
                    </p>
                    <ol>

                        a.       <strong>Recopilación en la plataforma.</strong> Para registrarse y crear una cuenta en NPLF con el fin de utilizar y acceder a la plataforma, o para facilitar de cualquier otro modo el uso y acceso continuado del usuario a la plataforma, se le pedirá al usuario que proporcione información y datos, incluyendo datos personales. En concreto, NPLF podrá recopilar en la plataforma los siguientes datos:

                    </ol>
                    <ol type='i' style={{ paddingLeft: 70 }}>
                        <li>
                            Datos personales, incluyendo (pero no limitado a):
                            <ol>
                                <li>
                                    nombre (primero y apellido);
                                </li>
                                <li>
                                    correo electrónico;
                                </li>
                                <li>
                                    número de teléfono;
                                </li>
                                <li>
                                    información de identificación única, como credenciales de inicio de sesión; y
                                </li>
                                <li>
                                    organización, institución educativa o distrito con el que el Usuario está empleado o afiliado.
                                </li>
                            </ol>
                        </li>
                        <li>
                            Datos de uso
                        </li>
                    </ol>
                    <p>
                        <span> </span>
                    </p>
                    <ol start="2">

                        b.      <strong>Recopilación en la plataforma.</strong> Por lo general, no recopilamos información ni datos sobre los Usuarios de la Plataforma. Sin embargo, NPLF puede recopilar la siguiente información y datos sobre los Usuarios:

                    </ol>

                    <ol type='i' style={{ paddingLeft: 70 }}>
                        <li>
                            Los Datos Personales que el Usuario facilite voluntariamente en la Plataforma (por ejemplo, en la página “Contacte con nosotros”), incluidos, entre otros, los siguientes
                            <ol>
                                <li>
                                    nombre (primero y apellido);
                                </li>
                                <li>
                                    correo electrónico;
                                </li>
                                <li>
                                    título; y
                                </li>
                                <li>
                                    organización, institución educativa o distrito con el que el Usuario está empleado o afiliado.
                                </li>
                            </ol>
                        </li>
                        <li>
                            Otra información del Usuario, como, por ejemplo:
                            <ol>
                                <li>
                                    solicitudes de material, información o servicios; y
                                </li>
                                <li>
                                    reportes de problemas, cuestiones o errores con la Plataforma.
                                </li>
                            </ol>
                        </li>
                        <li>
                            Cookies;
                        </li>
                        <li>
                            Datos de uso;
                        </li>
                        <li>
                            Registros web, consistentes en lo siguiente:
                            <ol>
                                <li>
                                    el dominio de Internet desde el que Usted accede a la Plataforma;
                                </li>
                                <li>
                                    Su dirección de Protocolo de Internet (IP);
                                </li>
                                <li>
                                    Su proveedor de servicios de Internet (ISP) utilizado para utilizar y acceder a la Plataforma;
                                </li>
                                <li>
                                    el tipo de navegador web y sistema operativo empleados por el Usuario;
                                </li>
                                <li>
                                    la fecha y hora en que el Usuario accedió, utilizó o visitó la Plataforma, incluyendo el tiempo promedio empleado por el Usuario; y
                                </li>
                                <li>
                                    las páginas web a las que accedió, utilizó o visitó en la Plataforma.
                                </li>
                            </ol>
                        </li>
                    </ol>
                    <p>
                        <span> </span>
                    </p>
                    <ol start="3">

                        c.      <strong>Recopilación automática.</strong> Cuando Usted navega por la Plataforma e interactúa con ella, podemos utilizar tecnologías automáticas de recogida de datos, como las Cookies, para recopilar determinada información sobre su equipo, acciones de navegación y patrones, incluyendo:

                    </ol>

                    <ol type='i' style={{ paddingLeft: 70 }}>
                        <li>
                            detalles de Sus visitas a la Plataforma, incluidos datos de tráfico, datos de ubicación, registros y otros datos de comunicación, así como los contenidos y recursos a los que Usted accede y utiliza en la Plataforma;
                        </li>
                        <li>
                            información sobre su dispositivo y conexión a Internet, incluida su dirección IP, proveedor de servicios de Internet (ISP), sistema operativo y tipo de navegador; e
                        </li>
                        <li>
                            información de localización, como la ubicación geográfica aproximada o real del Usuario.
                        </li>
                    </ol>
                    <p>
                        <span> </span>
                    </p>
                    <ol start="4">

                        d.      <strong>Retención.</strong> NPLF retendrá Su información, incluyendo Datos Personales, solo durante el tiempo que el Usuario utilice o acceda a la Plataforma y según sea necesario para los fines establecidos en esta Política de Privacidad. Además, conservaremos Su información, incluidos los Datos Personales, en la medida necesaria para cumplir con Nuestras obligaciones legales, resolver disputas y hacer cumplir Nuestros acuerdos legales y políticas.

                    </ol>
                    <p>
                        <span> </span>
                    </p>
                    <ol start="5">

                        e.      <strong>Uso.</strong> En general, no utilizamos ni explotamos la información y los datos, incluyendo los Datos Personales, de los Usuarios de esta Plataforma. Utilizamos su información y datos, incluidos sus Datos Personales y Datos de Uso:

                    </ol>

                    <ol type='i' style={{ paddingLeft: 70 }}>
                        <li>
                            para presentarle la Plataforma y sus contenidos, recursos y servicios a Usted;
                        </li>
                        <li>
                            para mantener la Plataforma y mejorar su navegación, funcionalidad y operatividad;
                        </li>
                        <li>
                            para ponernos en contacto con Usted para enviarle boletines o material promocional, publicitario o de marketing;
                        </li>
                        <li>
                            para ponernos en contacto con Usted en relación con cambios en la Política de Privacidad;
                        </li>
                        <li>
                            para proporcionarle información, contenidos, recursos, productos y servicios que pueda solicitar a NPLF;
                        </li>
                        <li>
                            para prestar apoyo al Usuario en relación con la Plataforma;
                        </li>
                        <li>
                            en su caso, para cumplir nuestras obligaciones y hacer valer nuestros derechos derivados de cualquier contrato celebrado entre Usted y NPLF;
                        </li>
                        <li>
                            para supervisar, observar o examinar el uso o el acceso a la Plataforma;
                        </li>
                        <li>
                            para detectar, prevenir y solucionar errores y problemas técnicos, tecnológicos o de servicio;
                        </li>
                        <li>
                            para permitirle a Usted involucrarse, participar, utilizar o activar las características interactivas de la Plataforma; y/o
                        </li>
                        <li>
                            por cualquier otro método o forma que especifiquemos cuando nos facilite dicha información, incluidos sus Datos Personales.
                        </li>
                    </ol>
                    <p>
                        <span> </span>
                    </p>
                    <ol start="6">

                        f.      <strong>Transferencia.</strong> Su información, incluyendo los Datos Personales, se transfiere a y se mantiene en Dispositivos o servidores ubicados en los Estados Unidos. Su información, incluyendo Datos Personales, puede ser transferida y mantenida en Dispositivos ubicados fuera de su estado, provincia, país u otra jurisdicción gubernamental donde las leyes de protección de datos pueden diferir de las de su jurisdicción. Su consentimiento a esta Política de Privacidad, seguido de Su envío de dicha información, incluyendo Datos Personales, representa Su acuerdo a dicha transferencia. NPLF tomará medidas razonables para garantizar que sus datos sean tratados de forma segura y de acuerdo con esta Política de Privacidad, y que no se produzca ninguna transferencia de sus Datos Personales a una organización de terceros o a un país, a menos que existan controles adecuados sobre la privacidad de su información, incluidos los Datos Personales, y el protocolo de seguridad de la información. Si se encuentra fuera de los Estados Unidos, tenga en cuenta que cualquier información, incluyendo los Datos Personales que nos proporcione, se transferirá a los Estados Unidos y dentro de este país. Al utilizar, acceder o visitar Nuestra Plataforma, Usted consiente esta transferencia.

                    </ol>
                    <p>
                        <span> </span>
                    </p>
                    <ol start="7">

                        g.      <strong>Divulgación.</strong> Generalmente, Nosotros no revelamos, liberamos, vendemos o intercambiamos información y datos, incluyendo Datos Personales, de Usuarios a terceras Personas. Y, generalmente no compartimos información y datos, incluyendo Sus Datos Personales, con anunciantes de terceros a menos que Usted le proporcione a NPLF permiso específico. Teniendo en cuenta lo anterior, podemos revelar su información y datos, incluyendo Sus Datos Personales, a:
                        <ol type='i' style={{ paddingLeft: 70 }}>
                            <li>
                                Nuestras subsidiarias, filiales, sucesores y cesionarios;
                            </li>
                            <li>
                                Terceros con el fin de generar informes para organizaciones de profesores, escuelas, centros comunitarios y centros de atención para demostrar el compromiso del usuario, la finalización del programa y otras métricas relevantes.
                            </li>
                            <li>
                                Contratistas, proveedores de servicios (tal y como se definen en el presente documento), vendedores externos y otros terceros a los que contratamos para respaldar nuestro modelo de negocio y nuestra Plataforma, y que están sujetos a obligaciones contractuales para mantener la confidencialidad y propiedad de su información, incluyendo Datos personales, y para utilizar su información, incluidos Datos personales, únicamente para los fines y por los motivos que revelamos;
                            </li>
                            <li>
                                Un comprador o cualquier sucesor en interés en el caso de una fusión, desinversión, reestructuración, reorganización, disolución u otra venta o transferencia de algunos o todos los activos de NPLF, ya sea como negocio en marcha o como parte de una quiebra, liquidación o procedimiento similar, en el que la información y los datos, incluidos los Datos Personales, en poder de NPLF sobre Nuestros Usuarios se encuentren entre los activos transferidos;
                            </li>
                            <li>
                                Cumplir con el propósito para el cual Usted proporcionó dicha información;
                            </li>
                            <li>
                                Cumplir con cualquier orden judicial, ley o proceso legal, incluyendo responder a cualquier solicitud gubernamental o regulatoria;
                            </li>
                            <li>
                                Otras partes, a la sola y absoluta discreción de NPLF, cuando dicha divulgación sea necesaria o apropiada para proteger los derechos, la propiedad o la seguridad de NPLF, los Usuarios, cualquier tercero con el que contratemos o nos comprometamos, u otros, incluyendo el intercambio de información con otras entidades con fines de protección contra el fraude y la reducción del riesgo de crédito;
                            </li>
                            <li>
                                Proteger y mantener la seguridad, operatividad, viabilidad, funcionalidad y fiabilidad de la Plataforma;
                            </li>
                            <li>
                                Prevenir o investigar infracciones potenciales, posibles, inminentes o reales en relación con la Plataforma; y
                            </li>
                            <li>
                                Atender otras necesidades, con Su previo consentimiento.
                            </li>
                        </ol>

                    </ol>
                    <p>
                        <span> </span>
                    </p>
                    <ol start="8">

                        h.      <strong>Facilitación. </strong>Podemos emplear a terceras entidades, individuos, contratistas y/o subcontratistas (“<strong>Proveedores de Servicios</strong>”) para facilitar la Plataforma, proporcionar la Plataforma en Nuestro nombre, realizar servicios relacionados con la Plataforma o ayudar a NPLF a analizar cómo se utiliza o accede a Nuestra Plataforma y su contenido, recursos y servicios. Estos proveedores de servicios pueden utilizar, acceder o divulgar su información, incluidos sus datos personales, con el fin de prestar servicios de facilitación. La NPLF utiliza los siguientes Proveedores de Servicios:

                    </ol>
                    <p>
                        <span> </span>
                    </p>
                    <ol type='i' style={{ paddingLeft: 70 }}>
                        <li >
                            Google Analytics, con la finalidad de medir datos e información relacionada con el tráfico, comportamiento y conversión, y cuya política de privacidad está disponible en https://policies.google.com/privacy y cuya información, contenidos y materiales sobre el uso de cookies y otras tecnologías de seguimiento está disponible en:
                        </li>
                    </ol>
                    <p>
                        <a href="https://developers.google.com/analytics/devguides/collection/analyticsjs/cookie-usage">https://developers.google.com/analytics/devguides/collection/analyticsjs/cookie-usage</a><span>.</span>
                    </p>
                    <p>
                        <span> </span>
                    </p>
                    <ol start="9">

                        i.      <strong>Agregación y anonimización.</strong> “<strong>Agregación</strong>” de datos e información se define generalmente como cualquier proceso en el que la información y los datos se reúnen y expresan en forma resumida. “<strong>Anonimización</strong>” se define como el proceso de eliminar información personal identificable (por ejemplo, Datos Personales) de conjuntos de datos, de modo que los individuos correspondientes permanezcan anónimos frente a la identificación. NPLF, a su entera y absoluta discreción y sin previo aviso, podrá agregar y anonimizar Datos Personales de modo que el producto final no le identifique personalmente a Usted ni a ningún otro Usuario de la Plataforma.

                    </ol>
                    <p>
                        <span> </span>
                    </p>
                    <ol start="10">

                        j.  <strong>Monitorización.</strong> Para garantizar la privacidad y seguridad de los Usuarios de la Plataforma (así como de terceras Personas), la NPLF puede monitorizar el uso o acceso a la Plataforma. Monitorizamos el uso o acceso a la Plataforma por las siguientes razones:
                        <ol type='i' style={{ paddingLeft: 70 }}>
                            <li>
                                para identificar actividades y transacciones fraudulentas;
                            </li>
                            <li>
                                para prevenir o investigar el daño o abuso potencial, amenazante, inminente o real a Usuarios o terceras Personas, así como prevenir el uso indebido o la explotación potencial, amenazante, inminente o real de la Plataforma;
                            </li>
                            <li>
                                para garantizar el cumplimiento y la aplicación de la presente Política de Privacidad;
                            </li>
                            <li>
                                para investigar posibles infracciones, amenazas de infracción, infracciones inminentes o infracciones reales de la presente Política de Privacidad; y
                            </li>
                            <li>
                                para proteger los derechos y la propiedad de los Usuarios, NPLF, y sus Proveedores de Servicios, contratistas, subcontratistas, vendedores, socios, clientes, clientes y otras terceras Personas.
                            </li>
                        </ol>

                    </ol>
                    <p>
                        <span> </span>
                    </p>

                    <strong>V. Acceso, rectificación, cancelación y supresión.</strong>

                    <p>
                        <strong><span> </span></strong>
                    </p>
                    <ol>

                        a.      <strong>Solicitudes</strong>. Las solicitudes para acceder, corregir o borrar información y datos personales, incluyendo Sus Datos Personales, deben ser enviadas haciendo referencia a la sección titulada “<strong>Comentarios, Inquietudes y Quejas</strong>”. Tenga en cuenta que es posible que no podamos eliminar, corregir o revisar Su información y datos, incluidos Sus Datos Personales, cuando NPLF esté legalmente obligada a conservar y mantener dicha información y datos.

                    </ol>
                    <p>
                        <span> </span>
                    </p>


                    <strong>VI. Seguridad de la información.</strong>

                    <p>
                        <strong><span> </span></strong>
                    </p>
                    <ol>

                        a.      <strong>Medidas de protección.</strong> Hemos implementado medidas físicas, administrativas y técnicas diseñadas para asegurar y proteger su información y datos, incluidos los Datos Personales, frente a pérdidas accidentales y frente al acceso, uso, alteración y divulgación no autorizados.

                    </ol>
                    <p>
                        <span> </span>
                    </p>
                    <ol start="2">

                        b.      <strong>Responsabilidad del usuario.</strong> La seguridad y protección de Su información, incluidos Sus Datos Personales, también depende de Usted, pues Usted es responsable de mantener la confidencialidad de las credenciales necesarias para acceder a la Plataforma. Le rogamos que no comparta sus credenciales con terceros.

                    </ol>
                    <p>
                        <span> </span>
                    </p>
                    <ol start="3">

                        c.      <strong>Transmisión por internet.</strong> Lamentablemente, la transmisión de información a través de Internet no es completamente segura. Aunque hacemos todo lo posible para proteger Su información personal, no podemos garantizar la seguridad de Su información y datos, incluyendo Sus Datos personales, transmitidos a la Plataforma o desde la misma. Toda transmisión de información y datos, incluidos sus Datos Personales, se realiza por su cuenta y riesgo. Tenga cuidado al enviar su información y datos, incluidos sus Datos personales, especialmente si accede a la Plataforma utilizando un punto de acceso Wi-Fi o una red pública. Si tiene motivos para creer que Su uso o acceso a la Plataforma ya no es seguro o no está protegido, notifique inmediatamente el problema a NPLF de acuerdo con la sección titulada “<strong>Comentarios, Inquietudes y Quejas</strong>”.

                    </ol>
                    <p>
                        <span> </span>
                    </p>
                    <ol start="4">

                        d.      <strong>Limitación de responsabilidad.</strong> SALVO QUE SE DISPONGA LO CONTRARIO EN LA PRESENTE POLÍTICA DE PRIVACIDAD, NPLF RECHAZA EXPRESAMENTE CUALQUIER DECLARACIÓN O GARANTÍA, YA SEA EXPRESA O IMPLÍCITA, CON RESPECTO A ASEGURAR, GARANTIZAR U OFRECER DE OTRO MODO CUALQUIER DECLARACIÓN O GARANTÍA DEFINITIVA DE SEGURIDAD EN RELACIÓN CON SU INFORMACIÓN Y DATOS, INCLUIDOS SUS DATOS PERSONALES, O INFORMACIÓN DE USO, Y RECHAZA ADEMÁS CUALQUIER RESPONSABILIDAD QUE PUEDA SURGIR, EN CASO DE QUE TERCEROS OBTENGAN LA INFORMACIÓN QUE USTED ENVÍA A LA PLATAFORMA.

                    </ol>
                    <p>
                        <span> </span>
                    </p>

                    <strong>VI. Terceros y sitios y recursos de terceros.</strong>

                    <p>
                        <strong><span> </span></strong>
                    </p>
                    <ol>

                        a.      <strong>Sitios y recursos de terceros</strong>. Nuestra Plataforma, y sus contenidos, recursos y servicios, pueden contener enlaces a, o conexiones con, sitios y recursos de terceros (“<strong>Sitios y Recursos de Terceros</strong>”) que no son operados, directa o indirectamente, por NPLF. Si Usted utiliza o selecciona cualquiera de los Sitios y Recursos de Terceros, será dirigido al sitio del tercero. El Usuario reconoce y acepta que NPLF no tiene control sobre y no asume ninguna responsabilidad por el contenido, las políticas de privacidad o las prácticas de los Sitios y Recursos de Terceros.

                    </ol>
                    <p>
                        <span> </span>
                    </p>
                    <ol start="2">

                        b.      <strong>Otras políticas de privacidad.</strong> En la medida en que Usted envíe, presente u ofrezca cualquier información o datos, incluyendo Sus Datos Personales, a cualquier Persona de terceros, la recopilación, uso y divulgación de dicha información por parte de dicha Persona de terceros puede estar regida por su política de privacidad, y no por Nuestra Política de Privacidad.

                    </ol>
                    <p>
                        <span> </span>
                    </p>
                    <ol start="3">

                        c.      <strong>Limitación de responsabilidad.</strong> NO SOMOS RESPONSABLES DE LA RECOPILACIÓN, EL USO, LA DIVULGACIÓN U OTRAS PRÁCTICAS DE PRIVACIDAD DE TERCEROS O DE SITIOS Y RECURSOS DE TERCEROS, INCLUIDOS NUESTROS PROVEEDORES DE SERVICIOS EXTERNOS, CUALQUIER PLATAFORMA DE MEDIOS SOCIALES DE TERCEROS (POR EJEMPLO, FACEBOOK, INSTAGRAM, X U OTROS), CUALQUIER TERCERO QUE PONGA A DISPOSICIÓN LOS DISPOSITIVOS O SISTEMAS OPERATIVOS PARA LOS QUE ESTÉN DISPONIBLES DETERMINADOS RECURSOS, CONTENIDOS O SERVICIOS DEL SITIO WEB (POR EJEMPLO, GOOGLE) Y CUALQUIER TERCERO QUE OPERE CUALQUIER SITIO AL QUE LA PLATAFORMA CONTENGA UN ENLACE O EN EL QUE ESTE SE ENCUENTRE. LA INCLUSIÓN DE UN ENLACE EN LA PLATAFORMA NO IMPLICA, DIRECTA O INDIRECTAMENTE, QUE NPLF O NUESTRAS FILIALES, SUCESORES Y CESIONARIOS APRUEBEN, PATROCINEN O TENGAN RELACIÓN ALGUNA CON EL SITIO ENLAZADO.

                    </ol>
                    <p>
                        <span> </span>
                    </p>
                    <p>
                        <span> </span>
                    </p>
                    <p>
                        <span> </span>
                    </p>

                    <strong>VII. Disposiciones generales.</strong>

                    <p>
                        <strong><span> </span></strong>
                    </p>
                    <ol>

                        a.      <strong>Condiciones de uso.</strong> Condicionado al uso y acceso a la Plataforma y sus contenidos, servicios y recursos, NPLF obliga al Usuario a aceptar y estar de acuerdo con la política de NPLF sobre sus términos y condiciones de uso (“<strong>Condiciones de Uso</strong>”), que se incorpora aquí por referencia en  <a href="http://platform.beginbright.org/terms">platform.beginbright.org/terms</a>

                    </ol>
                    <p>
                        <span> </span>
                    </p>
                    <ol start="2">

                        b.      <strong>Tecnología de No Seguimiento.</strong> La Plataforma continuará funcionando tal y como se describe en la presente Política de Privacidad, independientemente de que se reciba o no una señal de “<strong>No Seguimiento</strong>” o un mecanismo similar desde su navegador web. No admitimos la tecnología de No Seguimiento (“<strong>DNT</strong>” por sus siglas en inglés). Usted puede activar o desactivar <strong>DNT</strong> ajustando, modificando o cambiando la configuración de los navegadores web de Su preferencia.

                    </ol>
                    <p>
                        <span> </span>
                    </p>
                    <ol start="3">

                        b.      <strong>Comentarios, inquietudes y quejas. </strong>Todas las opiniones, comentarios, solicitudes de asistencia técnica y otras comunicaciones relacionadas con la Plataforma, los contenidos, recursos y servicios de lo anterior y la privacidad de Sus datos, incluidos los Datos Personales, deberán dirigirse a los agentes y representantes correspondientes por correo electrónico a: <a href="/cdn-cgi/l/email-protection#3811161e17381a1d1f11161a0a111f100c56170a1f"><span><span data-cfemail="c1e8efe7eec1e3e4e6e8efe3f3e8e6e9f5afeef3e6">[email protected]</span></span></a>

                    </ol>
                    <p>
                        <span> </span>
                    </p>
                    <p>
                        <em><span>Fecha de entrada en vigor: 1 de julio de 2025</span></em>
                    </p>

                </div>
            </div >

        </>

    );
};

export default PrivacyPolicy_es;
